import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  display: flex;
`;

export const LayersContainer = styled.div`
  width: 300px;
  background-color: ${C.GENERIC_GRAY};
  overflow-y: auto; 
`;
